<template>
    <div>
        <template v-for="(item, index) in items" :key="`faq-${index}`">
            <Disclosure>
                <div class="border-turquoise-dark border-b-2 first:border-t-2">
                    <DisclosureButton
                        :class="['hover:text-red flex w-full cursor-pointer items-center justify-between gap-x-8 py-3 text-left leading-snug transition-colors duration-300 md:gap-x-12 md:py-4 lg:gap-x-16']"
                        @click.prevent="toggle(index)"
                    >
                        <span class="h7 leading-snug">{{ item.question }}</span>
                        <ArrowRightIcon :class="[active === index ? 'rotate-90' : '', 'text-turquoise-dark my-1 size-4 shrink-0 transition-transform md:size-5']" />
                    </DisclosureButton>
                    <DisclosurePanel static>
                        <div ref="panels" class="overflow-hidden transition-all" :style="{ maxHeight: active === index ? heights[index] + 'px' : 0 }">
                            <div class="user-content text-gray pb-8 md:pr-6 lg:pr-16 [&_p]:text-sm" v-html="item.answer"></div>
                        </div>
                    </DisclosurePanel>
                </div>
            </Disclosure>
        </template>
    </div>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
import ArrowRightIcon from '../../../images/icons/arrow-right.svg';
import { computed, ref } from 'vue';

defineProps({
    items: { type: Array, required: true },
    borderSolid: { type: Boolean, default: false },
    borderTop: { type: Boolean, default: false },
});

const active = ref(null);
const panels = ref(null);

const heights = computed(() => {
    const val = [];

    if (panels.value) {
        panels.value.forEach((panel) => val.push(panel.scrollHeight));
    }

    return val;
});
/**
 * Toggle the active accordion item.
 *
 * @param {number} index The index of the item to toggle.
 */
function toggle(index) {
    active.value = index === active.value ? null : index;
}
</script>
